import { render } from "./PropertyFolderDisplay.vue?vue&type=template&id=e71657ea&scoped=true&ts=true"
import script from "./PropertyFolderDisplay.vue?vue&type=script&lang=ts"
export * from "./PropertyFolderDisplay.vue?vue&type=script&lang=ts"

import "./PropertyFolderDisplay.vue?vue&type=style&index=0&id=e71657ea&scoped=true&lang=css"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e71657ea"]])

export default __exports__